import { render } from "./AppWidgetWithIcon.vue?vue&type=template&id=695a4adc"
import script from "./AppWidgetWithIcon.vue?vue&type=script&lang=js"
export * from "./AppWidgetWithIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__